// Dependencies
import React, {useEffect, useState} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import PriceLevelList from './PricelevelList.tsx';
import Title from './Title.jsx';
import LeoHint from '../../../components/hint/LeoHint.jsx';
import {ThemeContext} from "../../../components/theme/Theme.jsx";
// Styles
import './CategoryZone.scss';


function CategoryZone(props: any) {
	const context = React.useContext(ThemeContext);
	const style = {
		catAvailability: {
			color: context.themeManager.value('category-hint-availability', 'color', 'bg-color-button-hightlight'),
			fontSize: context.themeManager.value('category-hint-availability', 'fontSize', 'font-size-100')
		},
        updateAlert: {
            backgroundColor: context.themeManager.valueOrDefault('category-hint-availability', 'alertBgColor', null,'#fff3cd'),
			color: context.themeManager.value('category-hint-availability', 'alertBgColor', 'fg-color-text'),
            padding: '10px',
            marginBottom: '10px',
            borderRadius: '4px',
            border: '1px solid #ffeeba',
            textAlign: 'center' as const,
            fontSize: '0.9em'
        },
	};
	const amountTicketsForShowingHint = parseInt(context.themeManager.valueOrDefault('category-hint-availability','amountOfTickets', null, 10))

	const [stableAvailableTicketsPerCategory, setStableAvailableTicketsPerCategory] = useState(props.availableTicketsPerCategory || {});
    const [showUpdateHint, setShowUpdateHint] = useState(false);
    const prevVolatileRef = React.useRef(props.volatileTicketAvailability);
    useEffect(() => {
        const oldVolatile = prevVolatileRef.current;
            const newVolatile = props.volatileTicketAvailability;
            const hasExternalChange = Object.keys(newVolatile).some(uuid => {
                const oldServerVal = oldVolatile[uuid] || 0;
                const newServerVal = newVolatile[uuid] || 0;
				return oldServerVal != newServerVal && newServerVal <= 10;
            });
            if (hasExternalChange) {
				setShowUpdateHint(true);
				setTimeout(() => setShowUpdateHint(false), 7000);
            }
            setStableAvailableTicketsPerCategory(props.availableTicketsPerCategory);
            prevVolatileRef.current = newVolatile;
    }, [props.availableTicketsPerCategory, props.volatileTicketAvailability]);


	return props.categories.length > 0 ?
		(
			<ul className="category-zone">
                {showUpdateHint && (
                    <div style={style.updateAlert}>
                        Die Ticket-Verfügbarkeit wurde gerade aktualisiert.
                    </div>
                )}
				{props.categories.map((category:any) => {
					const categoryUuid = category.categoryUUID;
					const ticketCount = stableAvailableTicketsPerCategory[categoryUuid];
					return (
					<li key={category.categoryUUID} className="category__li">
						<Title name={category.categoryName}>
							{ticketCount < 1 &&
								<LeoHint
									leoHintContainerStyle={{ marginTop: '0em', alignItems: 'baseline' }}
									hintText={context.themeManager.getThemeTextOrHardcodedDefault('categorySoldOutText')}
									popupHeadline={context.themeManager.getThemeTextOrHardcodedDefault('categorySoldOutPopupTitle')}
									popupText={context.themeManager.getThemeTextOrHardcodedDefault('categorySoldOutPopupText')}
								/>
							}
							{ticketCount > 0 && ticketCount <= amountTicketsForShowingHint && (
								<div className="category__hint--availability" style={style.catAvailability}>
									{`Nur noch ${ticketCount} Ticket(s) verfügbar!`}
								</div>
							)}
						</Title>
						{ticketCount > 0 &&
							<PriceLevelList
								categoryUuid={category.categoryUUID}
								standardPriceLevel={category.standardPriceLevel}
								reducedPriceLevels={category.reducedPriceLevels}
								ticketsAvailable={props.volatileTicketAvailability[category.categoryUUID]}
							/>
						}
					</li>
					)}
				)}
			</ul>
		) : null;
}

const RadiumCategoryZone = radium(CategoryZone);

const calcCategoryTicketsAvailableMap = (state: any, categories: any) => {
	const availableMap: Record<string, string> = {};
	for (const cat of categories) {
		availableMap[cat.categoryUUID] = [cat.standardPriceLevel ? cat.standardPriceLevel.priceLevelUuid : null, ...cat.reducedPriceLevels
			.map((pl:any) => pl.priceLevelUuid)]
		.map((plUuid) => state.eventPage.amountOfTicketsInCart[plUuid]).filter(el => el != null)
		.reduce((accu: any, availablePerPricelevel) => accu + availablePerPricelevel, state.eventPage.volatileTicketAvailability[cat.categoryUUID]);
	}
	return availableMap;
};


// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state: any, ownProps: any) => {
	const accessCodesEnabled = state.accessCodes.accessCodesEnabled;
	const accessCodePlUuidCodeMap = state.accessCodes.plUuidCodeMap;
	const categories = ownProps.categories;
	const filteredCategoriesWithFilteredPricelevels: any[] = [];

	if (accessCodesEnabled) {
		const accessCodePricelevels = Object.keys(accessCodePlUuidCodeMap);
		categories.forEach((category: any) => {
			if ((accessCodePricelevels.includes(category.standardPriceLevel.priceLevelUuid) || !category.standardPriceLevel.accessCodeNeeded ||
				(category.reducedPriceLevels.find((pl: any) => (accessCodePricelevels.includes(pl.priceLevelUuid) || !pl.accessCodeNeeded))))) {
				const filteredStandardPl = accessCodePricelevels.includes(category.standardPriceLevel.priceLevelUuid) ||
				!category.standardPriceLevel.accessCodeNeeded ?
					category.standardPriceLevel : null;
				const filteredReducedPl = category.reducedPriceLevels.filter((pl:any) =>
						(accessCodePricelevels.includes(pl.priceLevelUuid) || !pl.accessCodeNeeded));
				const categoryWithFilteredPl = Object.assign({}, category, {
					standardPriceLevel: filteredStandardPl,
					reducedPriceLevels: filteredReducedPl,
				});
				filteredCategoriesWithFilteredPricelevels.push(categoryWithFilteredPl);
			}
		});
	}

	return {
		categories: accessCodesEnabled ? filteredCategoriesWithFilteredPricelevels : categories,
		volatileTicketAvailability: state.eventPage.volatileTicketAvailability,
		availableTicketsPerCategory: calcCategoryTicketsAvailableMap(state, categories),
	};
};

const mapDispatchToProps = () => ({
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RadiumCategoryZone);

